import { SearchBoxComponent } from "./searchBox";

export const SearchBox = SearchBoxComponent;
